<template>
    <div class="elem-upload-box" dark-class="elem-upload-box-dark">
        <elem-input-object :name="name" :title="title" :required="required" :getValue="getFiles"></elem-input-object>
        <input ref="upload_input" class="upload-input" type="file" :accept="accept || types[type].accept" :multiple="multi" @change="onSelectFile" />
        <div ref="upload_drag" class="upload-drag-box" v-show="multi || files.length <= 0" @click="onClickUpload">
            <div class="icon-box">
                <elem-icon src="static/icon/components/elem-upload/" :name="type"></elem-icon>
            </div>
            <p class="name">点击上传，或将{{ types[type].name }}拖拽到此处</p>
        </div>
        <div class="upload-preview-box" v-if="files.length > 0" :style="{ 'margin-top': files.length > 0 ? '10px' : '0' }">
            <p class="preview-title">预览：</p>
            <div class="upload-preview-list">
                <div class="upload-file-box" v-for="(item, idx) in files" :key="idx">
                    <div class="upload-file-name">
                        <div>{{ item.name }}</div>
                    </div>

                    <div v-if="type === 'image'" class="upload-image-base">
                        <img :src="item.preview || item.url || item.src" class="upload-image" />
                    </div>

                    <div v-else-if="type === 'video'" class="upload-video-base">
                        <video v-if="type === 'video'" :src="item.preview || item.url || item.src" class="upload-video" controls></video>
                    </div>

                    <div v-else-if="type === 'audio'" class="upload-audio-base">
                        <audio v-if="type === 'audio'" :src="item.preview || item.url || item.src" class="upload-audio" controls></audio>
                    </div>

                    <div v-else class="upload-file-base">
                        <ElemIcon src="static/icon/components/elem-upload/" name="file"></ElemIcon>
                    </div>

                    <div class="upload-file-operating">
                        <div v-if="type === 'image'" class="upload-file-operating-button" @click="editImageById(item.id)">
                            <ElemIcon src="static/icon/components/elem-upload/" name="edit" dark="edit_white"></ElemIcon>
                        </div>
                        <div v-else class="upload-file-operating-button operating-button-disable" @click="editUploadDisable">
                            <ElemIcon src="static/icon/components/elem-upload/" name="edit" dark="edit_white"></ElemIcon>
                        </div>
                        <div class="upload-file-operating-move">
                            <div class="upload-file-operating-button upload-file-operating-move-before" @click="moveUpload(item.id, 'move-before')">
                                <ElemIcon src="static/icon/components/elem-upload/" name="move_left" dark="move_left_white"></ElemIcon>
                            </div>
                            <div class="upload-file-operating-button upload-file-operating-move-after" @click="moveUpload(item.id, 'move-after')">
                                <ElemIcon src="static/icon/components/elem-upload/" name="move_right" dark="move_right_white"></ElemIcon>
                            </div>
                        </div>
                        <div class="upload-file-operating-button" @click="deleteUpload(item.id)">
                            <elem-icon src="static/icon/components/elem-upload/" name="delete" dark="delete_white"></elem-icon>
                        </div>
                    </div>

                    <!-- 进度条 -->
                    <div class="upload-file-progress" v-if="item.progress !== undefined">
                        <div class="progress-mask"></div>
                        <div class="progress-circle">
                            <svg viewBox="0 0 100 100">
                                <circle class="progress-bg" cx="50" cy="50" r="45"></circle>
                                <circle class="progress-bar" cx="50" cy="50" r="45" :style="{ strokeDashoffset: 283 - (283 * item.progress) / 100 }"></circle>
                            </svg>
                            <span class="progress-text">{{ item.progress }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Utils from "@/module/utils/utils"
import Message from "@/module/interactive/message"
import FileUtil from "@/module/file/file_util"
import Loading from "@/module/loading/loading"
import Request from "@/module/request/request"
import Theme from "@/module/theme/theme"
import Language from "@/module/language/language"
import heic2any from "heic2any"

import elemInputObject from "./elem-input-object.vue"
import ElemIcon from "./elem-icon.vue"
import Crop from "@/module/crop/crop"

export default {
    props: {
        value: {
            type: Object,
            default: new Array(),
        },
        name: String,
        title: String,
        required: {
            type: Boolean,
            default: true,
        },
        multi: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "image",
        },
        size: String,
        filename: {
            type: String,
            default: "",
        },
        folder: {
            type: String,
            default: "",
        },
        accept: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            files: [],
            types: {
                image: {
                    name: "图片",
                    accept: "image/*",
                    url: "WEB://Resource/Image/Upload",
                },
                video: {
                    name: "视频",
                    accept: "video/*",
                    url: "WEB://Resource/Video/Upload",
                },
                audio: {
                    name: "音频",
                    accept: "audio/*",
                    url: "WEB://Resource/Audio/Upload",
                },
                file: {
                    name: "文件",
                    accept: "",
                    url: "WEB://Resource/File/Upload",
                },
            },
        }
    },

    components: {
        ElemIcon,
        elemInputObject,
    },

    created() {
        var value = this.value

        if (!value) return

        if ("string" === typeof value) {
            value = [
                {
                    src: value,
                },
            ]
        } else if (!(value instanceof Array)) {
            value = [value]
        }

        var files = []

        Utils.each<obj>(value, v => {
            files.push({
                id: Utils.getUuid(),
                ...v,
            })
        })

        // 如果外部传入了 sort，则按 sort 初始化顺序
        files.sort((a, b) => {
            const as = Utils.isBlank(a?.sort) ? null : Number(a.sort)
            const bs = Utils.isBlank(b?.sort) ? null : Number(b.sort)

            if (as === null && bs === null) return 0
            if (as === null) return 1
            if (bs === null) return -1

            return as - bs
        })

        this.files = files

        // 补齐 sort（以当前顺序为准）
        this.normalizeFilesSort()
    },
    mounted() {
        var dropbox = this.$refs.upload_drag

        dropbox.addEventListener("drop", this.enentDrop, false)

        dropbox.addEventListener("dragleave", e => {
            e.stopPropagation()
            e.preventDefault()
        })

        dropbox.addEventListener("dragenter", e => {
            e.stopPropagation()
            e.preventDefault()
        })

        dropbox.addEventListener("dragover", e => {
            e.stopPropagation()
            e.preventDefault()
        })

        // 处理主题数据
        Theme.processPage(this.$el)
        // 处理语言包数据
        Language.process(this)
    },
    methods: {
        normalizeFilesSort() {
            // sort 从 0 开始：与数组下标一致
            Utils.each<obj>(this.files, (v, i) => {
                if ((this as any).$set) {
                    const vm: any = this
                    vm.$set(v, "sort", i)
                } else {
                    v.sort = i
                }
            })
        },

        isHeicFile(file: File): boolean {
            const type = (file.type || "").toLowerCase()
            const ext = (file.name || "").split(".").pop()?.toLowerCase()

            return (
                type.includes("heic") ||
                type.includes("heif") ||
                ext === "heic" ||
                ext === "heif" ||
                ext === "heics" ||
                ext === "heifs"
            )
        },

        renameToPng(name: string): string {
            const base = name.replace(/\.[^/.]+$/, "")

            return `${base || "image"}.png`
        },

        async convertHeicToPngFile(file: File): Promise<File> {
            try {
                const converted = await heic2any({ blob: file, toType: "image/png" })
                const pngBlob = converted instanceof Blob ? converted : converted[0]

                return new File([pngBlob], this.renameToPng(file.name), { type: "image/png" })
            } catch (err) {
                // fallback：如果浏览器本身支持解码 HEIC（如 macOS Safari），用 canvas 转 png
                return await this.convertHeicToPngByBrowser(file)
            }
        },

        convertHeicToPngByBrowser(file: File): Promise<File> {
            return new Promise((resolve, reject) => {
                const url = URL.createObjectURL(file)
                const img = new Image()

                const cleanup = () => {
                    URL.revokeObjectURL(url)
                }

                img.onload = () => {
                    try {
                        const canvas = document.createElement("canvas")
                        canvas.width = img.naturalWidth || img.width
                        canvas.height = img.naturalHeight || img.height

                        const ctx = canvas.getContext("2d")
                        if (!ctx) {
                            cleanup()
                            return reject(new Error("Canvas 初始化失败"))
                        }

                        ctx.drawImage(img, 0, 0)

                        canvas.toBlob(
                            blob => {
                                cleanup()
                                if (!blob) return reject(new Error("PNG 生成失败"))

                                resolve(new File([blob], this.renameToPng(file.name), { type: "image/png" }))
                            },
                            "image/png",
                            1
                        )
                    } catch (e) {
                        cleanup()
                        reject(e)
                    }
                }

                img.onerror = () => {
                    cleanup()
                    reject(new Error("当前浏览器不支持 HEIC 解码"))
                }

                img.src = url
            })
        },

        enentDrop(evt) {
            evt.stopPropagation()
            evt.preventDefault()

            this.processFiles(evt.dataTransfer.files)
        },

        onClickUpload() {
            this.$refs.upload_input.click()
        },

        onSelectFile(evt) {
            this.processFiles((evt.target || evt.srcElement).files)
        },

        async processFiles(files) {
            for (let i = 0; i < files.length; i++) {
                await this.processFile(files[i])
                // var file = files[i]
            }

            // 清空 input 值
            this.$refs.upload_input.value = null
        },

        editUploadDisable() {
            Message.error("编辑功能仅支持图片格式")
        },

        processFile(file: File): Promise<void> {
            return new Promise(resolve => {
                const run = async () => {
                    const config = this.types[this.type]
                    const isHeic = this.isHeicFile(file)

                    if (isHeic && this.type !== "image") {
                        Message.error("HEIC 仅支持在图片上传中使用")
                        return
                    }

                    if (!isHeic && !new RegExp(config.accept).test(file.type)) {
                        Message.error(`不支持当前文件类型，仅支持 ${config.name} 类型`)
                        return
                    }

                    let workingFile = file

                    if (isHeic) {
                        try {
                            workingFile = await this.convertHeicToPngFile(file)
                        } catch (err) {
                            // 浏览器无法解码/转换 HEIC 时：立即上传原始 HEIC，由后端转 PNG 并返回预览地址
                            try {
                                Loading.show()

                                const formData = new FormData()
                                formData.append("file", file, file.name)

                                // 兼容原有图片上传参数
                                formData.append("name", this.filename)
                                formData.append("folder", this.folder)

                                const res = await Request.post<obj>(this.types[this.type].url, formData, {
                                    onFail: function (err) {
                                        const msg = JSON.parse(err.responseText).message
                                        Message.error(msg)
                                        return false
                                    },
                                })

                                const previewUrl = res?.url || res?.src

                                if (!previewUrl) {
                                    Message.error("后端未返回 PNG 预览地址")
                                    return
                                }

                                // 直接写入一个“已上传”的文件项：getFiles 时会走 path 分支（src）
                                this.files.push({
                                    id: Utils.getUuid(),
                                    name: this.renameToPng(file.name),
                                    url: previewUrl,
                                    src: previewUrl,
                                    // 保留后端其他字段（如有）
                                    ...res,
                                })

                                this.normalizeFilesSort()
                                return
                            } catch (uploadErr) {
                                console.error("HEIC upload failed", uploadErr)
                                Message.error("HEIC 上传失败")
                                return
                            } finally {
                                Loading.hide()
                            }
                        }
                    }

                    if (!this.multi && this.files.length > 0) {
                        Message.info("最多只能上传一个文件")
                        return
                    }

                    const dataUrl = await new Promise<string | ArrayBuffer | null>((resolveReader, rejectReader) => {
                        const reader = new FileReader()

                        reader.onerror = () => rejectReader(new Error("文件加载失败"))
                        reader.onload = () => resolveReader(reader.result)

                        reader.readAsDataURL(workingFile)
                    }).catch(err => {
                        Message.error(err?.message || "文件加载失败")
                        return null
                    })

                    if (!dataUrl) return

                    var res = dataUrl
                    var blob

                    if (this.type === "image" && Utils.isExist(this.size)) {
                        let data = await this.editImageByFile(res, this.size)

                        res = data.dataURL

                        if (data.blob) {
                            blob = data.blob
                        }
                    }

                    this.files.push({
                        id: Utils.getUuid(),
                        src: res,
                        name: workingFile.name,
                        ...(blob ? { blob } : { file: workingFile }),
                    })

                    this.normalizeFilesSort()
                }

                run()
                    .catch(err => {
                        console.error("processFile failed", err)
                        Message.error("文件处理失败")
                    })
                    .finally(() => resolve())
            })
        },

        moveUpload: function (id: string, type) {
            this.files = Utils.each<obj>(this.files, v => (v.id === id ? type : null))

            this.normalizeFilesSort()
        },

        editImageByFile(base64, size): Promise<obj> {
            return new Promise((resolve) => {
                const sizes = size.replace(/\s+/g, "").split("*")

                let w = sizes[0]
                let h = sizes[1]

                const image = new Image()

                image.onload = async () => {
                    // 宽高与指定宽高相等
                    if (image.width < w || image.height < h) {
                        let msg = "图片分辨率最低为：" + this.size

                        // 显示错误提示
                        Message.error(msg)
                    } else if (image.width === w && image.height === h) {
                        // resolve({ dataURL: base64, file })
                    } else {
                        // 判断是否初始化裁剪资源文件
                        if (!this.initializedCropResource) {
                            await this.initCropResource()
                        }

                        new Crop(base64, {
                            aspectRatio: w / h,
                            width: w,
                            height: h,
                        })
                            .onError(() => {
                                Message.error("图片裁剪失败")
                            })
                            .onConfirm(data => {
                                resolve(data)
                            })
                            .build()
                    }
                }

                image.onerror = () => {
                    Message.error("图片加载失败")
                }

                image.src = base64
            })
        },

        async editImageById(id) {
            // 判断是否初始化裁剪资源文件
            if (!this.initializedCropResource) {
                await this.initCropResource()
            }

            var config

            if (Utils.isExist(this.size)) {
                const sizes = this.size.replace(/\s+/g, "").split("*")

                let w = sizes[0]
                let h = sizes[1]

                config = {
                    aspectRatio: w / h,
                    width: w,
                    height: h,
                }
            }

            Utils.each<obj>(
                this.files,
                v => {
                    if (v.crop) v.crop.show()
                    else
                        v.crop = new Crop(v.preview || v.url || v.src, config)
                            .onError(function (err) {
                                Message.error(err)
                            })
                            .onConfirm(data => {
                                v.blob = data.blob
                                v.src = data.dataURL

                                v.url = null
                            })
                            .build()
                },
                v => v.id === id
            )
        },

        deleteUpload: function (id) {
            Message.info("确认删除该文件吗？", true)
                .onConfirm(() => {
                    Utils.each<obj>(this.files, function (d) {
                        return d.id === id ? "delete" : null
                    })

                    this.normalizeFilesSort()
                })
                .build()
        },

        // 初始化裁剪资源文件
        initCropResource(): Promise<void> {
            return new Promise((resolve) => {
                Loading.show()

                Promise.all([
                    FileUtil.style("./static/module/crop/cropper.min.css"),
                    FileUtil.script("./static/module/crop/cropper.min.js"),
                ])
                    .then(() => {
                        this.initializedCropResource = true

                        resolve()

                        Loading.hide()
                    })
                    .catch(() => {
                        Message.error("裁剪资源加载失败")
                    })
            })
        },

        getFiles: function () {
            return new Promise((resolve) => {
                const files = this.files

                if (!this.required && files.length <= 0) {
                    return resolve(null)
                }

                if (files.length <= 0) {
                    const msg = this.title + " 不能为空"

                    // Show Msg
                    Message.error(msg)
                    return resolve(null)
                }

                const ordered = [] as { v: obj; i: number; needUpload: boolean }[]

                Utils.each<obj>(files, function (v, i) {
                    ordered.push({ v, i, needUpload: !!(v.blob || v.file) })
                })

                const buildResult = (uploaded: obj[] = []) => {
                    let cursor = 0
                    const result: obj[] = []

                    Utils.each(ordered, row => {
                        const sort = row.i
                        const idx = row.i

                        if (row.needUpload) {
                            const up = uploaded[cursor++] || {}
                            result.push({ idx, sort, ...up })
                        } else {
                            // 已有 src/url 的资源：直接透传，同时补齐 sort
                            result.push({ idx, sort, ...row.v })
                        }
                    })

                    return this.multi ? result : result[0]
                }

                const filesToUpload = ordered.filter(r => r.needUpload)

                if (filesToUpload.length <= 0) {
                    resolve(buildResult([]))
                    return
                }

                const uploadedResults: obj[] = []

                const uploadTasks = async () => {
                    for (let row of filesToUpload) {
                        const fileItem = row.v
                        const fileData = fileItem.blob || fileItem.file
                        const fileName = fileItem.name

                        if ((this as any).$set) {
                            (this as any).$set(fileItem, 'progress', 0)
                        } else {
                            fileItem.progress = 0
                        }

                        const chunkSize = 512 * 1024 // 512KB 分片 (避免有些服务器默认最大允许 1MB 产生 500 MaxUploadSizeExceededException)
                        const totalChunks = Math.max(1, Math.ceil(fileData.size / chunkSize))
                        const identifier = Utils.getUuid()
                        let uploadedData = null

                        for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
                            const start = (chunkNumber - 1) * chunkSize
                            const end = Math.min(chunkNumber * chunkSize, fileData.size)
                            const chunkBlob = fileData.slice(start, end, fileData.type || '')
                            
                            // 包装成真正的 File 对象而不是 Blob，以保证兼容某些严格校验 filename 或 type 的后端实现
                            const chunkFile = new File([chunkBlob], fileName, { type: fileData.type || 'application/octet-stream' })

                            const formData = new FormData()
                            // 直接传 File 对象，浏览器会自动附加正确的 filename 等属性
                            formData.append("file", chunkFile)
                            
                            // 将所有参数一并传给后台，避免因缺少 name 引发后台拼接目录时的空指针
                            formData.append("name", this.filename || fileName)
                            
                            if (this.folder) {
                                formData.append("folder", this.folder)
                            }
                            if (this.type) {
                                formData.append("type", this.type)
                            }
                            
                            formData.append("chunkNumber", chunkNumber.toString())
                            formData.append("identifier", identifier)
                            formData.append("totalChunks", totalChunks.toString())

                            try {
                                const res = await new Promise((resolveReq, rejectReq) => {
                                    Request.post<obj[] | obj>(this.types[this.type].url, formData, {
                                        onFail: (err) => {
                                            let msg = "上传失败"
                                            try {
                                                msg = JSON.parse(err.responseText).message
                                            } catch (e) {
                                                // ignore
                                            }
                                            Message.error(msg)
                                            rejectReq(new Error(msg))
                                            return false
                                        },
                                        onProgress: (e) => {
                                            if (e.lengthComputable) {
                                                const chunkProgress = e.loaded / e.total
                                                const currentProgress = Math.floor(((chunkNumber - 1 + chunkProgress) / totalChunks) * 100)
                                                fileItem.progress = currentProgress > 100 ? 100 : currentProgress
                                            }
                                        }
                                    }).then(r => resolveReq(r)).catch(rejectReq)
                                })

                                fileItem.progress = Math.floor((chunkNumber / totalChunks) * 100)
                                if (chunkNumber === totalChunks) {
                                    uploadedData = res
                                }
                            } catch (e) {
                                if ((this as any).$delete) (this as any).$delete(fileItem, 'progress')
                                else delete fileItem.progress
                                throw e
                            }
                        }

                        if (uploadedData) {
                            await new Promise(r => setTimeout(r, 200)) // 等待动画完成呈现100%
                            if ((this as any).$delete) (this as any).$delete(fileItem, 'progress')
                            else delete fileItem.progress

                            if (uploadedData instanceof Array) {
                                uploadedResults.push(uploadedData[0])
                            } else {
                                uploadedResults.push(uploadedData as obj)
                            }
                        }
                    }
                }

                uploadTasks().then(() => {
                    resolve(buildResult(uploadedResults))
                }).catch(() => {
                    resolve(null)
                })
            })
        },
    },
}
</script>

<style lang="less">
@import "/src/module/crop/crop.less";
@import (reference) "/src/style/utils.less";

.elem-upload-box {
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .upload-input {
        display: none;
    }

    .upload-drag-box {
        position: relative;
        width: 100%;
        padding: 30px;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        .radius(6px);
        .border;

        .icon-box {
            width: 50px;
            height: 50px;
        }

        .name {
            margin-top: 15px;
            font-size: 13px;
        }
    }

    .upload-preview-box {
        width: 100%;
        box-sizing: border-box;
        border-left-width: 5px;
        padding: 10px;
        line-height: 22px;

        .radius(6px);
        .border;

        .preview-title {
            margin: 10px 10px 0;
        }

        .upload-preview-list {
            display: flex;
            flex-wrap: wrap;

            .upload-file-box {
                margin: 10px;
                max-width: 100%;
                display: inline-block;
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
                position: relative;

                .radius(6px);
                .border;

                .upload-file-name {
                    position: relative;
                    width: 100%;
                    height: 30px;

                    .border-position(bottom);

                    div {
                        position: absolute;
                        top: 0;
                        left: 20px;
                        right: 20px;
                        bottom: 0;
                        text-align: center;
                        line-height: 30px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }

                .upload-image-base,
                .upload-video-base {
                    width: 100%;
                    height: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .upload-image-base .upload-image {
                    width: initial;
                    height: initial;
                    max-width: 100%;
                    max-height: 100%;
                }

                .upload-video-base .upload-video {
                    max-width: 300px;
                    height: 150px;
                    max-height: 100%;
                }

                .upload-audio-base {
                    width: 100%;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #eff1f3;

                    .upload-audio {
                        max-width: 300px;
                        height: 50px;
                        max-height: 100%;
                    }
                }

                .upload-file-base {
                    width: 100%;
                    height: 100px;
                    padding: 20px 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .upload-file-operating {
                    padding: 0 10px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .border-position(top);

                    .upload-file-operating-button {
                        cursor: pointer;
                        width: 30px;
                        height: 30px;
                        padding: 5px;
                        display: flex;
                        border-radius: 5px;

                        .border-box;

                        &:hover {
                            box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
                        }
                    }

                    .upload-file-operating-move {
                        display: flex;
                    }

                    .operating-button-disable {
                        opacity: 0.5;
                        cursor: not-allowed;
                    }
                }

                &:first-child .upload-file-operating-move-before,
                &:last-child .upload-file-operating-move-after {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                &:first-child .upload-file-operating-move-before:hover,
                &:last-child .upload-file-operating-move-after:hover {
                    box-shadow: initial;
                }

                .upload-file-progress {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 10;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    overflow: hidden;

                    .progress-mask {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.4);
                        backdrop-filter: blur(3px);
                    }

                    .progress-circle {
                        position: relative;
                        width: 60px;
                        height: 60px;
                        z-index: 11;

                        svg {
                            width: 100%;
                            height: 100%;
                            transform: rotate(-90deg);

                            circle {
                                fill: none;
                                stroke-width: 6;
                                stroke-linecap: round;

                                &.progress-bg {
                                    stroke: rgba(255, 255, 255, 0.2);
                                }

                                &.progress-bar {
                                    stroke: #1890ff;
                                    stroke-dasharray: 283;
                                    transition: stroke-dashoffset 0.3s ease;
                                }
                            }
                        }

                        .progress-text {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: #fff;
                            font-size: 13px;
                            font-weight: 500;
                            text-shadow: 0 1px 2px rgba(0,0,0,0.5);
                        }
                    }
                }
            }
        }
    }
}

.elem-upload-box-dark {
    .upload-drag-box {
        background: #252a31;
        border-color: #373a4e;
    }

    .upload-preview-box {
        border-color: #373a4e;

        .upload-preview-list .upload-file-box {
            border-color: #373a4e;

            .upload-file-name,
            .upload-file-operating {
                border-color: #373a4e;
            }
        }
    }
}
</style>
